import React from 'react'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import GavelIcon from '@mui/icons-material/Gavel'
import { useTranslation } from 'react-i18next'
import { DetailedSteps } from '../../../app/data/stepper'


export const CustomStepper = () => {
  const { t } = useTranslation()
  return (
    <div className='w-50 stepper-box'>
      {DetailedSteps.map((step, index) => (
        <Step
          key={index}
          label={t(step.label)}
          mirror={step.mirror}
          descriptions={step.descriptions}
        />
      ))}
      <div className='position-relative'>
        <GavelIcon fontSize='large' className='position-absolute circle-around' />
        <p className='position-absolute underneath-text final-text'>{t('stepper.start_bidding')}</p>
      </div>
    </div>
  )
}

interface StepperDescriptionInterface {
  text: string
  mirror: boolean
}
interface CustomStepInterface {
  label: string
  mirror?: boolean
  descriptions: StepperDescriptionInterface[]
}

const Step = ({ label, mirror = false, descriptions }: CustomStepInterface) => {
  const { t } = useTranslation()
  return (
    <div className='position-relative step-box border-left border-dark'>
      {/* <RadioButtonUncheckedIcon className='position-absolute stepper-circle' /> */}
      {/* <p className={` ${mirror ? 'mirrored-title' : 'unmirrored-title'} step-title`}>
        {label}
      </p> */}
      <p className={'step-title'}>
        {label}
      </p>
      {descriptions.map((desc, index) => {
        return (
          <p
            key={index}
            className={`${desc.mirror ? 'mirrored-text' : 'unmirrored-text'} step-text stepper-subdescription-${index + 1}`}
          >
            {t(desc.text)}
          </p>
        )
      })}
    </div>
  )
}
